<script>
import { reactive, ref, computed, onMounted, provide } from '@vue/composition-api';
import insertVoucherForm from './insert-voucher-form.vue';
import checkedVoucherResume from './checked-voucher-resume.vue';
import confirmVoucherRedeemed from './confirm-voucher-redeemed.vue';

export default {
    props: ['redeemUrl', 'validateUrl'],
    setup(props) {
        const status_insert = "status_insert"
        const status_checked = "status_checked"
        const status_confirmed = "status_confirmed"

        const status = ref(status_insert)
        const voucherCredits = ref(null)
        const voucher = ref(null)
        const cookies = ref(null)
        provide('redeemUrl', props.redeemUrl)
        provide('validateUrl', props.validateUrl)
        provide('voucherCredits', voucherCredits)
        provide('voucher', voucher)
        provide('status', status)
        provide('status_checked', status_checked)
        provide('status_insert', status_insert)
        provide('status_confirmed', status_confirmed)
        provide('cookies', cookies)

        const trans = {

        }
        return {
            trans,
            status_insert,
            status_checked,
            status_confirmed,
            status,
            voucherCredits,
            cookies
        }
    },
    mounted() {
        console.log("Mounted redeem voucher component")
        this.cookies = this.$cookies

    },
    components: { insertVoucherForm, checkedVoucherResume, confirmVoucherRedeemed}
}
</script>

<template>
    <div>
        <hr class="my-2">
        <insertVoucherForm v-show="status === status_insert"></insertVoucherForm>
        <checkedVoucherResume v-show="status === status_checked"></checkedVoucherResume>
        <confirmVoucherRedeemed v-show="status === status_confirmed"></confirmVoucherRedeemed>
    </div>
</template>